import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { RoundStatus, userInfoStore, useTranslation } from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import BetsClosingPopUp from './betsClosingPopUp';
import { YouWinPopUp } from './youWinPopUp';
// eslint-disable-next-line import/no-named-as-default
import Striker from './striker';
import { doBetStore, gameStore } from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';
import { soundsStore } from '../../../../store/soundStore';

const GameMainTop = observer(() => {
  const t = useTranslation();
  const {
    isShowWinPopUp,
    betData: { isDisabled },
    finishedOdd,
    winAmount,
  } = doBetStore;
  const { status } = gameStore.gameState;
  const { duration } = roundInfoStore;
  const { soundsStates, updateSoundsStates } = soundsStore;
  const {
    time,
    isHummerHit,
    timerDuration,
    oddRenderCount,
    setOddRenderCount,
    gameAnimationDuration,
  } = gameStore;
  const { isAnimationOn } = userSettingsStore;
  const { BetsAreClosing, BetsAreClosed, PlaceYourBets } = globalTranslationKeys;
  const { currencySymbolOrCode } = userInfoStore;
  // eslint-disable-next-line consistent-return
  const decidePopUpContent = useCallback(() => {
    const calculatePercentOfTheTime = Math.round((timerDuration * 30) / 100);
    if (+time > +calculatePercentOfTheTime) {
      return t(PlaceYourBets);
    }
    if (!time && isDisabled) {
      return t(BetsAreClosed);
    }
    if (+time <= +calculatePercentOfTheTime) {
      return t(BetsAreClosing);
    }
  }, [time, isDisabled]);

  const showWinPopUp = () => !!winAmount && doBetStore.updateIsShowWinPopUp(true);

  useEffect(() => {
    if (status === RoundStatus.Started) {
      gameStore.setTimerDuration(time);
    }
  }, [isAnimationOn]);

  return (
    <>
      <div className='striker-game-content'>
        {(isDisabled || time) && <BetsClosingPopUp decidePopUpContent={decidePopUpContent} />}
        {/* popup win START */}
        {!!winAmount && isShowWinPopUp && (
          <YouWinPopUp currencyCode={currencySymbolOrCode} amount={winAmount} t={t} />
        )}
        {/* popup win END */}
        <Striker
          t={t}
          time={time}
          status={status}
          duration={duration}
          finishedOdd={finishedOdd}
          isHummerHit={isHummerHit}
          showWinPopUp={showWinPopUp}
          soundsStates={soundsStates}
          isAnimationOn={isAnimationOn}
          oddRenderCount={oddRenderCount}
          setOddRenderCount={setOddRenderCount}
          updateSoundsStates={updateSoundsStates}
          gameAnimationDuration={gameAnimationDuration}
        />
      </div>
    </>
  );
});

export default GameMainTop;
